import { ExperiencesTabType } from '../../../types/experiences-tab.type';
import { ExperiencesTabEnum } from '../../../types/experiences-tab.enum';

export const ExperiencesTabs: ExperiencesTabType[] = [
    {
        tab: ExperiencesTabEnum.PORCUPINE_CREEK_TEMPORAL,
        image: 'porcupine-creek-temporal.png',
    },
];
